import angular from 'angular';
import uiRouter from 'angular-ui-router';
import stModalComponent from './stModal.component';

let stModalModule = angular.module('stModal', [
  uiRouter
])

.component('stModal', stModalComponent)
.name;

export default stModalModule;



// WEBPACK FOOTER //
// ./client/app/common/stModal/stModal.js